interface IModalState {
  showType?: ValueOf<IModalTypes>;
}

const actions = {
  SHOW: 'lms-ui/modal/SHOW',
};

interface IModalAction {
  type: typeof actions.SHOW;
  payload?: ValueOf<IModalTypes>;
}

type ModalActionTypes = IModalAction;

const initialState: IModalState = {
  showType: undefined,
};

export const showModal = (type?: ValueOf<IModalTypes>): ModalActionTypes => {
  return { type: actions.SHOW, payload: type };
};

export default function reducer(state = initialState, action: ModalActionTypes): IModalState {
  switch (action.type) {
    case actions.SHOW: {
      return {
        ...state,
        showType: action.payload,
      };
    }
    default:
      return state;
  }
}
